import { AlphabetCyrillicIcon } from './AlphabetCyrillicIcon';

/**
 * author: Haley Halcyon
 * id 197B613F-AF17-41DE-B2A6-7FCB8D86C366
 * name alphabet-cyrillic
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alphabet-cyrillic.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemCyrillicIcon = AlphabetCyrillicIcon;
export default WritingSystemCyrillicIcon